import i18next from 'i18next';
import { getMarket } from '../i18n';

export const togglableFilters = () => {
  const { marketCode } = getMarket();
  const filters = [
    {
      id: 'mrf',
      displayName: i18next.t('filter.associationPackaging', { ns: 'search' }),
    },
    {
      id: 'isAuthorizedResellerForManufacturer',
      displayName: i18next.t('filter.authorizedDealer', { ns: 'search' }),
    },
    {
      id: 'hasManufacturerPackaging',
      displayName: i18next.t('filter.manufacturerPackaging', { ns: 'search' }),
    },
    {
      id: 'hasMedia',
      displayName: i18next.t('filter.onlyWithMedia', { ns: 'search' }),
    },
    {
      id: 'leasing',
      displayName: i18next.t('Private leasing', { ns: 'search' }),
    },
    {
      id: 'businessLeasing',
      displayName: i18next.t('Business leasing', { ns: 'search' }),
    },
    {
      id: 'isAuctionItem',
      displayName: i18next.t('Auction', { ns: 'search' }),
    },
  ];

  if (marketCode === 'SE') {
    filters.splice(0, 0, {
      id: 'deductibleVat',
      displayName: i18next.t('filter.deductibleVat', { ns: 'search' }),
    });

    filters.splice(5, 0, {
      id: 'ecom',
      displayName: i18next.t('filter.buyOnline', { ns: 'search' }),
    });
  }

  return filters;
};

export const toggleableExcludingFilters = () => [
  {
    id: 'isCentralStorage',
    displayName: i18next.t('filter.centralStorage.displayName', { ns: 'search' }),
    tagDisplayName: i18next.t('filter.centralStorage.tagName', { ns: 'search' }),
  },
];
